function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarClock = function SvgCalendarClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.66231 16.6725H3.3223C2.96824 16.6725 2.62868 16.5319 2.37832 16.2815C2.12796 16.0311 1.9873 15.6916 1.9873 15.3375V4.65751C1.9873 4.30345 2.12796 3.96388 2.37832 3.71352C2.62868 3.46316 2.96824 3.32251 3.3223 3.32251H15.3373C15.6914 3.32251 16.0309 3.46316 16.2813 3.71352C16.5317 3.96388 16.6723 4.30345 16.6723 4.65751V8.66251",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9873 7.32739H16.6723",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99219 4.65755V1.98755",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667 4.65755V1.98755",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.672 22.0125C19.6212 22.0125 22.012 19.6217 22.012 16.6725C22.012 13.7233 19.6212 11.3325 16.672 11.3325C13.7228 11.3325 11.332 13.7233 11.332 16.6725C11.332 19.6217 13.7228 22.0125 16.672 22.0125Z",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0331 16.6724H16.6729V14.313",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgCalendarClock;